import { useState } from "react";

type SummaryRow = {
  eventType: string;
  sectionId: string;
  questionId: string;
  choice: string;
  count: number;
};

export function AdminDashboard() {
  const [token, setToken] = useState("");
  const [rows, setRows] = useState<SummaryRow[]>([]);
  const [error, setError] = useState("");

  async function loadSummary() {
    setError("");
    try {
      const response = await fetch("/api/events/summary", {
        headers: { "x-admin-token": token }
      });

      if (!response.ok) {
        setError("Token 不正确，或者服务端暂时不可用。");
        setRows([]);
        return;
      }

      setRows(await response.json());
    } catch {
      setError("服务端暂时不可用。");
      setRows([]);
    }
  }

  async function exportCsv() {
    if (!token) {
      setError("请输入管理 token 后再导出。");
      return;
    }

    setError("");
    try {
      const response = await fetch("/api/events/export", {
        headers: { "x-admin-token": token }
      });
      if (!response.ok) {
        setError("Token 不正确，或者服务端暂时不可用。");
        return;
      }

      const url = window.URL.createObjectURL(await response.blob());
      const link = document.createElement("a");
      link.href = url;
      link.download = "shuatibao-roadshow-feedback.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      setError("服务端暂时不可用。");
    }
  }

  return (
    <main className="admin-panel">
      <h1>互动反馈后台</h1>
      <p>只展示匿名聚合数据，用于会后看大家更关心什么。</p>
      <div className="admin-controls">
        <input
          value={token}
          onChange={(event) => setToken(event.target.value)}
          aria-label="FEEDBACK_ADMIN_TOKEN"
          type="password"
        />
        <button type="button" onClick={loadSummary}>
          查看汇总
        </button>
        <button type="button" onClick={exportCsv}>
          导出 CSV
        </button>
      </div>
      {error ? <p className="admin-error">{error}</p> : null}
      <div className="summary-table-wrap">
        <table className="summary-table">
          <thead>
            <tr>
              <th>事件</th>
              <th>章节</th>
              <th>问题</th>
              <th>选择</th>
              <th>次数</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={`${row.eventType}-${row.sectionId}-${row.questionId}-${row.choice}`}>
                <td>{row.eventType}</td>
                <td>{row.sectionId}</td>
                <td>{row.questionId}</td>
                <td>{row.choice}</td>
                <td>{row.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </main>
  );
}
